import { PortabilityDatesInterfaceState, initialPortabilityDatesState } from '../state/portability-dates.state';
import { PortabilityDatesActions, EPortabilityDatesActions } from '../actions/portability-dates.actions';

export function portabilityDatesReducer(state: PortabilityDatesInterfaceState = initialPortabilityDatesState, action: PortabilityDatesActions): PortabilityDatesInterfaceState {
  switch (action.type) {
    case EPortabilityDatesActions.GetPortabilityDatesSuccess: {
      return { ...state, list: action.payload };
    }

    default:
      return state;
  }
};
